import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isMobileMedia } from 'bento-ordering/utils/media';
import {
  selectCartGroupOrderAdminName,
  selectIsGroupOrderCurrentDinerDoneOrdering
} from 'bento-ordering/cart/selectors/index';
import {
  Header,
  Body,
  OrderConfirmedMenuDesktopSnackbar,
  OrderConfirmedMenuMobileSnackbar,
  OrderConfirmedCartDesktopSnackbar,
  OrderConfirmedCartMobileSnackbar
} from 'bento-ordering/group_ordering/ui_components/OrderConfirmedSnackbarComponents';

const GroupOrderOrderConfirmedSnackbar = ({ isCart = false }) => {
  const mobileMedia = isMobileMedia();
  const dinerAdminName = useSelector(selectCartGroupOrderAdminName);
  const isDinerDoneOrdering = useSelector(
    selectIsGroupOrderCurrentDinerDoneOrdering
  );
  const getMessage = () => {
    let headText = '';
    let bodyText = '';
    if (isDinerDoneOrdering) {
      headText = 'Items confirmed!';
      bodyText = `You will be notified once ${dinerAdminName} submits the order. You can not manage your cart anymore.`;
    } else {
      headText = `${dinerAdminName} has confirmed the order.`;
      bodyText =
        'You can not manage your cart anymore. Everything that has been in your cart was submitted';
    }
    return (
      <>
        <Header>{headText}</Header>
        <br />
        <Body>{bodyText}</Body>
      </>
    );
  };

  const MobileSnackBar = isCart
    ? OrderConfirmedCartMobileSnackbar
    : OrderConfirmedMenuMobileSnackbar;
  const DesktopSnackBar = isCart ? (
    <OrderConfirmedCartDesktopSnackbar
      open={true}
      message={getMessage()}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
    />
  ) : (
    <OrderConfirmedMenuDesktopSnackbar open={true} message={getMessage()} />
  );

  const OrderConfirmedSnackbar = mobileMedia ? (
    <MobileSnackBar open={true} message={getMessage()} />
  ) : (
    DesktopSnackBar
  );

  return OrderConfirmedSnackbar;
};

GroupOrderOrderConfirmedSnackbar.propTypes = {
  isCart: PropTypes.bool.isRequired
};

export default GroupOrderOrderConfirmedSnackbar;
